var getAccountDetailsMapper = function (getAccountDetails) {
    if (getAccountDetails) {
        return {
            registeredGuestAccount: getAccountDetails.rgtrdGstAc,
            clientAccount: getAccountDetails.clientAc,
            status: getAccountDetails.sts == "0" ? false : true,
            guestId: getAccountDetails.guestId,
        };
    }
    return {};
};
export default getAccountDetailsMapper;
